export const defaultBeneficiaryCdkScrollConfig = {
  itemSize: 64,
  minBufferPx: 340,
  maxBufferPx: 400,
};
